import { selectors } from 'publisher/reducers/blogReducer'
import { shallowEqual, useSelector } from 'react-redux'

export { selectors }

export default function useBlog(selector) {
  return useSelector(state => selector(state.blog), shallowEqual)
}
